var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.023,
    height: 24.558,
    viewBox: "0 0 27.023 24.558",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#4e4e57}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    transform: "translate(-145.964 -142.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    fill: "#7eb12a",
    d: "M11.61 23.217A11.609 11.609 0 1 1 11.61 0a9.827 9.827 0 0 1 1.878.17 11.61 11.61 0 0 0 0 22.876 9.829 9.829 0 0 1-1.878.171z",
    transform: "translate(145.963 143.459)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_delay_3181152",
    transform: "translate(146.09 142.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1858"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6721",
    d: "M82.279 114.558a12.279 12.279 0 1 1 12.279-12.279.585.585 0 0 1-1.169 0 11.1 11.1 0 1 0-.924 4.444.585.585 0 0 1 1.072.468 12.284 12.284 0 0 1-11.258 7.367z",
    className: "cls-2",
    transform: "translate(-70 -90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1859",
    transform: "translate(11.694 4.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6722",
    d: "M274.093 178.186h-3.508a.585.585 0 0 1-.585-.586v-7.017a.585.585 0 0 1 1.169 0v6.432h2.924a.585.585 0 0 1 0 1.169z",
    className: "cls-2",
    transform: "translate(-270 -170)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    transform: "translate(19.88 8.186)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6723",
    d: "M414.092 234.678a.582.582 0 0 1-.324-.1l-3.508-2.339a.585.585 0 1 1 .649-.973l3.022 2.015 2.015-3.022a.585.585 0 0 1 .973.649l-2.339 3.508a.584.584 0 0 1-.488.262z",
    className: "cls-2",
    transform: "translate(-409.999 -230)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/watch.589689350e0da315ca266766a014c32b.svg";
export { ForwardRef as ReactComponent };